import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "tw-form-control" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

import { InterviewQuestionResponseModel, Variant } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import { computed, onMounted, ref } from 'vue'
import FlatButton from '@/components/Shared/FlatButton.vue'
import vSelect from 'vue-select';

import 'vue-select/dist/vue-select.css';
import { scrollToElementBottom } from '../scrollToElementBottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDownQuestion',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as { question: InterviewQuestionResponseModel };

const answer = ref<Variant | undefined>(undefined)
const isSubmited = ref<boolean>(false)
const touched = ref(false);



const interviewStore = useInterviewStore()

const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const isSubmitable = computed(() => !!answer.value?.Label)

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return;
    }

    interviewStore.nextQuestion()
    isSubmited.value = true

    interviewStore.changeAnswer(props.question.Id, answer.value!.Label!);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "dropdown-question-desc",
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(vSelect), {
        label: __props.question.Label,
        "aria-label": __props.question.Label,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (touched.value = true)),
        "aria-required": "true",
        "aria-invalid": touched.value && !_unref(isSubmitable),
        "aria-describedby": "dropdown-question-desc",
        options: __props.question.Variants,
        class: "tw-form-control__dropdown",
        dir: "rtl",
        clearable: false,
        searchable: false,
        modelValue: answer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((answer).value = $event))
      }, {
        option: _withCtx(({ Label }) => [
          _createElementVNode("div", { innerHTML: Label }, null, 8, _hoisted_5)
        ]),
        "selected-option": _withCtx(({ Label }) => [
          _createElementVNode("div", { innerHTML: Label }, null, 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["label", "aria-label", "aria-invalid", "options", "modelValue"])
    ]),
    (_unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 1,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})